



























































































































































import Vue from "vue";
import Component from "vue-class-component";

@Component({
  name: "Home",
  components: {}
  // Toutes les options de composant sont autorisées ici.
})
export default class Home extends Vue {
  goToTest() {
    this.$router.push("quiz");
  }
  headers = [
    {
      text: "N°",
      align: "start",
      value: "id"
    },
    { text: "Date", value: "date" },
    { text: "Résultat", value: "actions", sortable: false }
  ];
  values = [];
  icons = [
    {
      icon: "mdi-instagram",
      link:
        "https://www.instagram.com/identidys_echelle_reperage_dys/?hl=fr-ca",
      color: "indigo"
    },
    {
      icon: "mdi-youtube",
      link: "https://www.youtube.com/channel/UCvFJprs2zEJPLu2vNuUkFcw",
      color: "red"
    },
    {
      icon: "mdi-web",
      link: "https://www.identidys.com/",
      color: "primary"
    }
  ];
  open(link: string) {
    window.open(link, "_blank");
  }

  mounted() {
    const item = localStorage.getItem("data");
    if (item) {
      this.values = JSON.parse(item);
    }
  }
  reset() {
    localStorage.setItem("data", JSON.stringify([]));
    this.values = [];
  }

  setResult(item: any) {
    this.$store.state.quizzes = item.data;
    this.$router.push("result");
  }
}
